<template>
  <div style="overflow-x: hidden">
    <h1 style="width: 0; height: 0; opacity: 0; visibility: hidden; overflow: hidden; margin: 0">
      {{ $t("common.faq") }}
    </h1>
    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">
          {{ $t("common.faq") }}
        </h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("common.home") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("faq.faq") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="dg-faq-content overflow">
      <div class="container">
        <div class="filters-button-group overflow row">
          <div class="col-md-3">
            <div class="d-flex relative filters-item selected">
              <div class="filters-img">
                <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/faq/image_1668146635_1.svg" alt="Products" />
              </div>
              <div class="filters-right">
                <h4 class="filters-title" style="margin-bottom: 8px">
                  {{ $t("faq.products") }}
                </h4>
                <div class="filters-desc"></div>
              </div>
              <a @click="type = 0" class="filters-link"></a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="d-flex relative filters-item">
              <div class="filters-img">
                <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/faq/image_1668146659_2.svg" alt="Orders" />
              </div>
              <div class="filters-right">
                <h4 class="filters-title" style="margin-bottom: 8px">
                  {{ $t("faq.orders") }}
                </h4>
                <div class="filters-desc"></div>
              </div>
              <a @click="type = 1" class="filters-link"></a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="d-flex relative filters-item">
              <div class="filters-img">
                <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/faq/image_1668146670_3.svg" alt="Delivery" />
              </div>
              <div class="filters-right">
                <h4 class="filters-title" style="margin-bottom: 8px">
                  {{ $t("faq.delivery") }}
                </h4>
                <div class="filters-desc"></div>
              </div>
              <a @click="type = 2" class="filters-link"></a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="d-flex relative filters-item">
              <div class="filters-img">
                <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/faq/image_1668146683_4.svg" alt="Return &amp; Exchange" />
              </div>
              <div class="filters-right">
                <h4 class="filters-title" style="margin-bottom: 8px">
                  {{ $t("faq.exchange") }}
                </h4>
                <div class="filters-desc"></div>
              </div>
              <a @click="type = 3" class="filters-link"></a>
            </div>
          </div>
        </div>
        <div class="faq-accordion" id="accordion">
          <template v-if="type === 0">
            <div key="1" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p1") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse1" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p2") }}
                </div>
              </div>
            </div>
            <div key="2" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p3") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse2" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p4") }}
                </div>
              </div>
            </div>
            <div key="3" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p5") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse3" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p6") }}
                </div>
              </div>
            </div>
            <div key="4" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p7") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse4" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p8") }} <br />
                  &nbsp;
                </div>
              </div>
            </div>
            <div key="5" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p9") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse5" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p10") }}
                </div>
              </div>
            </div>
            <div key="6" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p11") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse6" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p12") }}
                  <ul>
                    <li>{{ $t("faq.p13") }}</li>
                    <li>{{ $t("faq.p14") }}</li>
                    <li>{{ $t("faq.p15") }}</li>
                    <li>{{ $t("faq.p16") }}</li>
                    <li>{{ $t("faq.p17") }}</li>
                  </ul>

                  <p>{{ $t("faq.p18") }}</p>
                </div>
              </div>
            </div>
            <div key="7" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p19") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse7" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p20") }}
                </div>
              </div>
            </div>
            <div key="8" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p21") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse8" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p22") }}
                </div>
              </div>
            </div>
            <div key="9" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p23") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse9" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p24") }} <br />
                  <br />
                  {{ $t("faq.p25") }}
                  <h2>{{ $t("faq.p26") }}</h2>
                  <br />
                  {{ $t("faq.p27") }} <br />
                  <br />
                  {{ $t("faq.p28") }}
                  <ul>
                    <li>{{ $t("faq.p29") }}</li>
                    <li>{{ $t("faq.p30") }}</li>
                    <li>{{ $t("faq.p31") }}</li>
                    <li>{{ $t("faq.p32") }}</li>
                    <li>{{ $t("faq.p33") }}</li>
                  </ul>
                  {{ $t("faq.p34") }}
                </div>
              </div>
            </div>
            <div key="10" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p35") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p36") }}
                </div>
              </div>
            </div>
          </template>

          <template v-if="type === 1">
            <!--订单模块-->
            <div key="11" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p37") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p38") }}
                </div>
              </div>
            </div>
            <div key="12" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p39") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p40") }} <br />
                  {{ $t("faq.p41") }}
                </div>
              </div>
            </div>
            <div key="13" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p42") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p43") }}
                </div>
              </div>
            </div>
          </template>

          <template v-if="type === 2">
            <!--交货-->
            <div key="14" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p44") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p45") }}
                </div>
              </div>
            </div>
            <div key="15" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p46") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body" v-html="$t('faq.p47')"></div>
              </div>
            </div>
            <div key="16" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p48") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body" v-html="$t('faq.p49')"></div>
              </div>
            </div>
            <div key="17" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p50") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body" v-html="$t('faq.p51')"></div>
              </div>
            </div>
          </template>

          <template v-if="type === 3">
            <!--退换货-->
            <div key="18" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p52") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p53") }}
                </div>
              </div>
            </div>
            <div key="19" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p54") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p55") }}
                </div>
              </div>
            </div>
            <div key="20" class="panel wow fadeInUp" style="visibility: hidden; animation-name: none">
              <div class="panel-heading">
                <button data-toggle="collapse" data-parent="#accordion">
                  <span> {{ $t("faq.p56") }} </span>
                  <div class="panel-icon">
                    <i class="fa fa-plus icon icon-plus"></i>
                    <i class="fa fa-minus icon icon-minus"></i>
                  </div>
                </button>
              </div>
              <div id="collapse10" class="panel-collapse collapse">
                <div class="panel-body">
                  {{ $t("faq.p57") }}
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="digood-pagination-wrap">
          <nav digood-id="list_pagination_1_oyh"></nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: 0
    }
  },
  watch: {
    type() {
      $(function () {
        $(".faq-accordion > .panel").length &&
          $(".faq-accordion .panel-heading").on("click", function () {
            $(this).toggleClass("active-panel"), $(this).parent(".panel").children(".panel-collapse").slideToggle()
          })
      })
    }
  },
  mounted() {
    $(function () {
      $(".faq-accordion > .panel").length &&
        $(".faq-accordion .panel-heading").on("click", function () {
          $(this).toggleClass("active-panel"), $(this).parent(".panel").children(".panel-collapse").slideToggle()
        })
    })
  }
}
</script>
<style scoped>
.dg-faq-content {
  padding: 60px 0 80px;
}

.dg-faq-content .filters-button-group {
  margin: 0 0 45px;
}

.dg-faq-content .filters-button-group .filters-item {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #505050;
  font-size: 20px;
  color: #505050;
  padding: 6px 16px;
  transition: 0.5s;
  cursor: pointer;
}

.dg-faq-content .filters-button-group .filters-item.selected {
  color: var(--main-theme-color);
}

.dg-faq-content .filters-button-group .filters-link {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.dg-faq-content .filters-button-group .filters-img {
  width: 40px;
  text-align: center;
}

.dg-faq-content .filters-button-group .filters-right {
  flex: 1;
  margin-left: 10px;
}

.dg-faq-content .filters-button-group .filters-title {
  font-size: 16px;
}

.dg-faq-content .filters-button-group .filters-desc {
  font-size: 14px;
  line-height: 18px;
}

.dg-faq-content .panel {
  box-shadow: 0 0 13px 0 rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  border-bottom: 0;
}

.dg-faq-content .panel-heading {
  color: #282828;
  padding: 10px 14px;
  font-weight: 500;
  position: relative;
}

.dg-faq-content .panel-heading a {
  font-size: 18px;
  color: #282828;
  display: block;
}

.dg-faq-content .panel-heading span {
  display: block;
  margin-right: 40px;
}

.dg-faq-content .panel-heading .panel-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 30px;
}

.dg-faq-content .panel-heading .icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  color: #282828;
  font-size: 14px;
  text-align: center;
  line-height: 32px;
  opacity: 1;
}

.dg-faq-content .panel-heading.active-panel .icon-minus {
  opacity: 1;
}

.dg-faq-content .panel-heading.active-panel .icon-plus {
  opacity: 0;
}

.dg-faq-content .panel-body li {
  list-style: inherit;
}
</style>
